import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb"
import CancelledOrderLayer from "../components/CancelledOrderLayer";
import usePermission from "../hook/usePermission";
import AccessDeniedLayer from "../components/AccessDeniedLayer";

const CancelledOrders = () => {
    const hasPermission = usePermission("cancelledOrder", "view"); // Using specific cancelled order permission
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>

                {/* Breadcrumb */}
                <Breadcrumb title="Cancelled Orders" header="Cancelled Order List" />

                {/* Layer */}
                {hasPermission ? <CancelledOrderLayer /> : <AccessDeniedLayer />}


            </MasterLayout>
        </>
    );
};

export default CancelledOrders;
